import {
  AudioLines,
  Mail,
  Image,
  Link,
  Mic,
  Play,
  StickyNote,
  X,
  CircleHelp,
  MessageCircle,
} from 'lucide-react';

export interface accordionType {
  question: string;
  answer: string;
}

type ServiceMapping = {
  label: string;
  icon: React.ComponentType<React.SVGProps<SVGSVGElement>>;
};

// Define a type for the entire service mapping object
type ServiceMappings = Record<string, ServiceMapping>;

export const serviceMappings: ServiceMappings = {
  ask: { label: 'Ask me anything', icon: CircleHelp },
  tweet: { label: 'Generate for X', icon: X },
  email_gen: { label: 'Email', icon: Mail },
  summarizer: { label: 'Link Summariser', icon: Link },
  explain_like_five: { label: 'Explain Like five', icon: Play },
  image: { label: 'Text to Image', icon: Image },
  tts: { label: 'Text to Speech', icon: Mic },
  stt: { label: 'Speech to Text', icon: AudioLines },
  chatwkb: { label: 'Chat Knowledge Base', icon: MessageCircle },
  chatwdoc: { label: 'Chat with Document', icon: StickyNote },
};

export const accordion = [
  {
    question:
      '1. Why do I need to set an advanced configuration for the Telegram bot?',
    answer:
      'Setting an advanced configuration allows you to define usage limits and reset periods for different services within the Telegram bot builder. You can specify how often each service (such as "Generate for X," "Email," and "Text to Speech") resets and the maximum number of times it can be used within that period. This ensures better control over resource allocation and helps manage usage effectively.',
  },
  {
    question:
      '2. When can I configure the ChatWKB service for my Telegram bot, and why is a document required?',
    answer:
      'You can configure the ChatWKB service only after creating your Telegram bot. This setup allows you to define usage limits and reset periods for the service. Additionally, a document (PDF, DOC, or DOCX, up to 20MB) is required as it serves as the knowledge base for the bot, enabling it to provide relevant responses based on the uploaded content.',
  },
  {
    question:
      '3. When can I set my Telegram bot to Online, Offline, or Restart it?',
    answer:
      'You can change your bots status (Online, Offline, or Restart) only after clicking "Change Configuration" and saving your settings. This ensures that all service selections, advanced configurations, and required documents are properly set before the bot goes live. Once configured, you can switch your bot online to start responding to users, set it offline to pause interactions, or restart it to apply any new updates instantly.',
  },
];
